export default "__VITE_ASSET__BdDHh_$N__"